import { type TableColumn } from 'src/shared/components/Table/Table';
import { useTranslation } from 'react-i18next';
import { type SelfFundedAccountTopUp } from 'src/shared/types/company';
import { datePrettifier } from 'src/modules/DataReview/helpers';
import { CountryCodes, CurrencyCodes, formatCurrency, invertSign } from 'src/shared/utils/currency';
import { SaldoItemStatus } from 'src/modules/SaldoView/components/CompanySelectorBar/components/SaldoItem';

type UseGetColumnsParams = {
  locale?: CountryCodes;
  currency?: CurrencyCodes;
};

export const useGetColumns = ({
  locale = CountryCodes.SPAIN,
  currency = CurrencyCodes.SPAIN
}: UseGetColumnsParams = {}): Array<TableColumn<SelfFundedAccountTopUp>> => {
  const { t } = useTranslation(['common']);

  return [
    {
      accessor: 'date',
      title: t('table.date'),
      renderCell: ({ date }) => datePrettifier(date)
    },
    {
      accessor: 'amount',
      title: t('table.amount'),
      renderCell: ({ amount }) => `${formatCurrency(locale, currency, 2, 'exceptZero')(Number(amount))}`
    }
  ];
};
